import Home from "@/viewModels/sessions/Home";
import EmailAuthorization from "@/viewModels/sessions/signup/emailAuthorization/EmailAuthorization";
import EmailAuthorizationSent from "@/viewModels/sessions/signup/emailAuthorization/EmailAuthorizationSent";
import PhoneNumberAuthorization from "@/viewModels/sessions/signup/phoneNumberAuthorization/PhoneNumberAuthorization";
import VerifyPhoneNumberAuthorization
  from "@/viewModels/sessions/signup/phoneNumberAuthorization/VerifyPhoneNumberAuthorization";
import Profile from "@/viewModels/sessions/signup/profile/Profile";
import WorkHistory from "@/viewModels/sessions/signup/WorkHistory";
import Preview from "@/viewModels/sessions/signup/Preview";
import RegistrationCompleted from "@/viewModels/sessions/signup/RegistrationCompleted";
import AccountReviewPassed from "@/viewModels/sessions/signup/AccountReviewPassed";
import Completed from "@/viewModels/sessions/signup/Completed";
import Suspended from "@/viewModels/sessions/signup/Suspended";
import ReviewFailed from "@/viewModels/sessions/signup/ReviewFailed";


const SIGNUP_ROUTES = [
  { path: '/', name: 'signup', components: { default: Home } },
  { path: 'email_authorization', name: 'emailAuthorization', component: EmailAuthorization, meta: { title: 'メール認証' } },
  { path: 'email_authorization/sent', name: 'emailAuthorizationSent', component: EmailAuthorizationSent, meta: { title: 'メール認証' } },
  { path: 'phone_number_authorization', name: 'phoneNumberAuthorization', component: PhoneNumberAuthorization, meta: { title: '電話認証' } },
  { path: 'phone_number_authorization/verify', name: 'verifyPhoneNumberAuthorization', component: VerifyPhoneNumberAuthorization, meta: { title: '電話認証' } },
  { path: 'profile', name: 'profile', component: Profile, meta: { title: '基本情報入力' } },
  { path: 'work_history', name: 'workHistory', component: WorkHistory, meta: { title: '職歴入力' } },
  { path: 'preview', name: 'preview', component: Preview, meta: { title: 'プレビュー' } },
  { path: 'registration_completed', name: 'registrationCompleted', component: RegistrationCompleted, meta: { title: 'アカウント作成完了' } },
  { path: 'account_review_passed', name: 'accountReviewPassed', component: AccountReviewPassed, meta: { title: '審査完了' } },
  { path: 'review_failed', name: 'reviewFailed', component: ReviewFailed, meta: { title: '審査完了' } },
  { path: 'completed', name: 'completed', component: Completed, meta: { title: '登録完了' } },
  { path: 'suspended', name: 'suspended', component: Suspended, meta: { title: '利用停止中' } },
];

export default SIGNUP_ROUTES;
